const LOCALSTORAGE_STATE_USUARIO = 'state.usuario'

export const verificarState = (state) => {
  if (state.usuario && state.usuario.accessToken == null) {
    state.usuario = JSON.parse(localStorage.getItem(LOCALSTORAGE_STATE_USUARIO))
  }
}

export const getAccessToken = (state) => {
  verificarState(state)
  if (state.usuario) {
    return state.usuario.accessToken
  }
  return null
}

export const getUsuario = (state) => {
  verificarState(state)
  return state.usuario
}

export const getUsuarioLogado = (state) => {
  verificarState(state)
  return state.usuario.desLogin
}

export const getUsuarioNome = (state) => {
  verificarState(state)
  if (state.usuario) {
    return state.usuario.nomUsuario
  }
  return null
}

export const getCodUsuario = (state) => {
  verificarState(state)
  return state.usuario.codUsuario
}
